// import Layout from '@/page/layout/home'
import LayoutNoFooter from '@/page/layout/index'

/**
 * meta.scene：
 * 1:班级放学操作屏
 * 2:班级放学显示屏
 * 4:滞留生家长签到显示屏（滞留室学生看）
 * 5:滞留生显示屏（家长看）
 * 6:家长签到显示屏（学生看）
 *
 */
export default [
    {
        path: '/leave',
        name: 'leave',
        component: LayoutNoFooter,
        children: [
            {
                path: 'child-leave-list-index',
                name: 'child-leave-list-index',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/leave/child-leave-list-index'),
                props: route => ({
                }),
                meta: {
                    title: '请假数据',
                    isAuth: true,
                }
            },
            {
                path: 'audit-leave-index',
                name: 'audit-leave-index',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/leave/audit-leave-index'),
                props: route => ({
                }),
                meta: {
                    title: '请假审核',
                    isAuth: true,
                }
            },
            {
                path: 'report-leave-index',
                name: 'report-leave-index',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/leave/report-leave-index'),
                props: route => ({
                }),
                meta: {
                    title: '销假管理',
                    isAuth: true,
                }
            },
            {
                path: 'squad-leave-index',
                name: 'squad-leave-index',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/leave/squad-leave-index'),
                props: route => ({
                }),
                meta: {
                    title: '请假查看',
                    isAuth: true,
                }
            },
        ]
    },
]
